import MaterialAccountCircle from '@mui/icons-material/AccountCircle';
import MaterialAddReactionOutlined from '@mui/icons-material/AddReactionOutlined';
import MaterialArticleOutlined from '@mui/icons-material/ArticleOutlined';
import MaterialAssignment from '@mui/icons-material/Assignment';
import MaterialAssignmentOutlined from '@mui/icons-material/AssignmentOutlined';
import MaterialAssistant from '@mui/icons-material/Assistant';
import MaterialAvTimer from '@mui/icons-material/AvTimer';
import MaterialBackHandOutlined from '@mui/icons-material/BackHandOutlined';
import MaterialBarChartRounded from '@mui/icons-material/BarChartRounded';
import MaterialCalendarMonth from '@mui/icons-material/CalendarMonth';
import MaterialCalendarMonthOutlined from '@mui/icons-material/CalendarMonthOutlined';
import MaterialCellTowerRounded from '@mui/icons-material/CellTowerRounded';
import MaterialChatBubbleOutline from '@mui/icons-material/ChatBubbleOutline';
import MaterialCheckBoxOutlined from '@mui/icons-material/CheckBoxOutlined';
import MaterialClosedCaption from '@mui/icons-material/ClosedCaption';
import MaterialClosedCaptionOffOutlined from '@mui/icons-material/ClosedCaptionOffOutlined';
import MaterialCommit from '@mui/icons-material/Commit';
import MaterialConstructionRounded from '@mui/icons-material/ConstructionRounded';
import MaterialDescriptionOutlined from '@mui/icons-material/DescriptionOutlined';
import MaterialEvent from '@mui/icons-material/Event';
import MaterialFormatListNumbered from '@mui/icons-material/FormatListNumbered';
import MaterialForumOutlined from '@mui/icons-material/ForumOutlined';
import MaterialFullscreenOutlined from '@mui/icons-material/FullscreenOutlined';
import MaterialGroups from '@mui/icons-material/Groups';
import MaterialGroups2Outlined from '@mui/icons-material/Groups2Outlined';
import MaterialGroupsOutlined from '@mui/icons-material/GroupsOutlined';
import MaterialHeadphones from '@mui/icons-material/Headphones';
import MaterialHearing from '@mui/icons-material/Hearing';
import MaterialHubOutlined from '@mui/icons-material/HubOutlined';
import MaterialInsertEmoticonOutlined from '@mui/icons-material/InsertEmoticonOutlined';
import MaterialLabelOutlined from '@mui/icons-material/LabelOutlined';
import MaterialLanguage from '@mui/icons-material/Language';
import MaterialLogoutOutlined from '@mui/icons-material/LogoutOutlined';
import MaterialManageAccountsOutlined from '@mui/icons-material/ManageAccountsOutlined';
import MaterialPause from '@mui/icons-material/Pause';
import MaterialPauseOutlined from '@mui/icons-material/PauseOutlined';
import MaterialPeopleAltOutlined from '@mui/icons-material/PeopleAltOutlined';
import MaterialPersonAddAlt1Outlined from '@mui/icons-material/PersonAddAlt1Outlined';
import MaterialPersonAddAltOutlined from '@mui/icons-material/PersonAddAltOutlined';
import MaterialPersonOffOutlined from '@mui/icons-material/PersonOffOutlined';
import MaterialPlayArrow from '@mui/icons-material/PlayArrow';
import MaterialPlayArrowOutlined from '@mui/icons-material/PlayArrowOutlined';
import MaterialQueryStatsOutlined from '@mui/icons-material/QueryStatsOutlined';
import MaterialQuestionAnswerOutlined from '@mui/icons-material/QuestionAnswerOutlined';
import MaterialRocketOutlined from '@mui/icons-material/RocketOutlined';
import MaterialSettingsInputAntenna from '@mui/icons-material/SettingsInputAntenna';
import MaterialSettingsOutlined from '@mui/icons-material/SettingsOutlined';
import MaterialSpeed from '@mui/icons-material/Speed';
import MaterialStop from '@mui/icons-material/Stop';
import MaterialSupportOutlined from '@mui/icons-material/SupportOutlined';
import MaterialTagOutlined from '@mui/icons-material/TagOutlined';
import MaterialTimelineOutlined from '@mui/icons-material/TimelineOutlined';
import MaterialUnpublishedOutlined from '@mui/icons-material/UnpublishedOutlined';
import MaterialVerifiedOutlined from '@mui/icons-material/VerifiedOutlined';
import MaterialVolumeDown from '@mui/icons-material/VolumeDown';
import MaterialVolumeUp from '@mui/icons-material/VolumeUp';
import MaterialWifi from '@mui/icons-material/Wifi';
import { createMaterialIcon, createSvgIcon } from 'common/theme/utils';

import Add from './Add.svg?react';
import ArrowRight from './ArrowRight.svg?react';
import ArrowUp from './ArrowUp.svg?react';
import AutoRenew from './AutoRenew.svg?react';
import BarChart from './BarChart.svg?react';
import BookSpark from './BookSpark.svg?react';
import BorderColor from './BorderColor.svg?react';
import Calendar from './Calendar.svg?react';
import CancelPresentationFilled from './CancelPresentationFilled.svg?react';
import ChartSelect from './ChartSelect.svg?react';
import Chat from './Chat.svg?react';
import Check from './Check.svg?react';
import CheckFilled from './CheckFilled.svg?react';
import ChevronDown from './ChevronDown.svg?react';
import ChevronLeft from './ChevronLeft.svg?react';
import ChevronRight from './ChevronRight.svg?react';
import ChevronUp from './ChevronUp.svg?react';
import Close from './Close.svg?react';
import Copy from './Copy.svg?react';
import Delete from './Delete.svg?react';
import DoubleArrowLeft from './DoubleArrowLeft.svg?react';
import Download from './Download.svg?react';
import DragIndicator from './DragIndicator.svg?react';
import Duplicate from './Duplicate.svg?react';
import Edit from './Edit.svg?react';
import EmojiFilled from './EmojiFilled.svg?react';
import EmojiOutlined from './EmojiOutlined.svg?react';
import ErrorFilled from './ErrorFilled.svg?react';
import ErrorOutlined from './ErrorOutlined.svg?react';
import ExitToApp from './ExitToApp.svg?react';
import Filter from './Filter.svg?react';
import Forum from './Forum.svg?react';
import FramePersonOff from './FramePersonOff.svg?react';
import FramePersonOn from './FramePersonOn.svg?react';
import GoogleColoured from './GoogleColoured.svg?react';
import GroupOutlined from './GroupOutlined.svg?react';
import HandFilled from './HandFilled.svg?react';
import HandOutlined from './HandOutlined.svg?react';
import HelpOutlined from './HelpOutlined.svg?react';
import HomeOutlined from './HomeOutlined.svg?react';
import Image from './Image.svg?react';
import InfoFilled from './InfoFilled.svg?react';
import InfoOutlined from './InfoOutlined.svg?react';
import Insights from './Insights.svg?react';
import Link from './Link.svg?react';
import Lock from './Lock.svg?react';
import Login from './Login.svg?react';
import Logout from './Logout.svg?react';
import Menu from './Menu.svg?react';
import MicrophoneOffFilled from './MicrophoneOffFilled.svg?react';
import MicrophoneOffOutlined from './MicrophoneOffOutlined.svg?react';
import MicrophoneOn from './MicrophoneOn.svg?react';
import MoreHorizontal from './MoreHorizontal.svg?react';
import MoreVertical from './MoreVertical.svg?react';
import OutlookColoured from './OutlookColoured.svg?react';
import Participants from './Participants.svg?react';
import PersonOutlined from './PersonOutlined.svg?react';
import PhoneFilled from './PhoneFilled.svg?react';
import { swap } from './phosphorMapping';
import Pin from './Pin.svg?react';
import PlayCircle from './PlayCircle.svg?react';
import PowerSettings from './PowerSettings.svg?react';
import PresentToAll from './PresentToAll.svg?react';
import RadioButtonChecked from './RadioButtonChecked.svg?react';
import RaisedHand from './RaisedHand.svg?react';
import RecordVoiceOver from './RecordVoiceOver.svg?react';
import Replay from './Replay.svg?react';
import Restart from './Restart.svg?react';
import ScreenShare from './ScreenShare.svg?react';
import Search from './Search.svg?react';
import Send from './Send.svg?react';
import Settings from './Settings.svg?react';
import SettingsAccount from './SettingsAccount.svg?react';
import SettingsFilled from './SettingsFilled.svg?react';
import Share from './Share.svg?react';
import ShareScreen from './ShareScreen.svg?react';
import Speaker from './Speaker.svg?react';
import Star from './Star.svg?react';
import TriangleArrowDown from './TriangleArrowDown.svg?react';
import TriangleArrowUp from './TriangleArrowUp.svg?react';
import Upload from './Upload.svg?react';
import Videocam from './Videocam.svg?react';
import VideocamOff from './VideocamOff.svg?react';
import VideocamOutlined from './VideocamOutlined.svg?react';
import VisibilityLock from './VisibilityLock.svg?react';
import VisibilityOff from './VisibilityOff.svg?react';
import VisibilityOn from './VisibilityOn.svg?react';
import VoiceOverOff from './VoiceOverOff.svg?react';
import WarningFilled from './WarningFilled.svg?react';
import WarningOutlined from './WarningOutlined.svg?react';
import WifiBad from './WifiBad.svg?react';
import WifiMedium from './WifiMedium.svg?react';
import WifiOk from './WifiOk.svg?react';

export * from './material';

export const AccountCircleIcon = createMaterialIcon(
  MaterialAccountCircle,
  'AccountCircle',
  'AccountCircle',
  swap('AccountCircleIcon')
);
export const ArticleOutlinedIcon = createMaterialIcon(
  MaterialArticleOutlined,
  'ArticleOutlined',
  'ArticleOutlined',
  swap('ArticleOutlinedIcon')
);
/**
 * A document with lines of text. Added for the backstage "Words transcribed" metric (HNS-366), which
 * had been rendering `ParticipantsIcon` because both metric rows shared one hardcoded glyph.
 *
 * `DescriptionOutlined` on the legacy path rather than `ArticleOutlined`, which the barrel already
 * exports: Phosphor's `FileText` has the folded corner, and Material's `Description` is the one of
 * the two Material glyphs that also has it. Reusing `ArticleOutlinedIcon` would have meant the same
 * export changing shape between flag states.
 *
 * A separate export rather than repointing `ArticleOutlinedIcon`'s swap, which has its own call
 * sites that did not ask to become a different glyph.
 *
 * The `testId` is MUI's string, not ours — this factory's legacy branch adds no `data-testid` of its
 * own, so passing `FileText` would have emitted `DescriptionOutlinedIcon` with the flag off and
 * `FileTextIcon` with it on, and a test could only ever assert one of them.
 */
export const FileTextIcon = createMaterialIcon(
  MaterialDescriptionOutlined,
  'DescriptionOutlined',
  'FileText',
  swap('FileTextIcon')
);
export const AssignmentIcon = createMaterialIcon(
  MaterialAssignment,
  'Assignment',
  'Assignment',
  swap('AssignmentIcon')
);
export const AssignmentOutlinedIcon = createMaterialIcon(
  MaterialAssignmentOutlined,
  'AssignmentOutlined',
  'AssignmentOutlined',
  swap('AssignmentOutlinedIcon')
);
export const AssistantIcon = createMaterialIcon(MaterialAssistant, 'Assistant', 'Assistant', swap('AssistantIcon'));
export const AvTimerIcon = createMaterialIcon(MaterialAvTimer, 'AvTimer', 'AvTimer', swap('AvTimerIcon'));
export const BackHandOutlinedIcon = createMaterialIcon(
  MaterialBackHandOutlined,
  'BackHandOutlined',
  'BackHandOutlined',
  swap('BackHandOutlinedIcon')
);
export const BarChartRoundedIcon = createMaterialIcon(
  MaterialBarChartRounded,
  'BarChartRounded',
  'BarChartRounded',
  swap('BarChartRoundedIcon')
);
export const CalendarMonthIcon = createMaterialIcon(
  MaterialCalendarMonth,
  'CalendarMonth',
  'CalendarMonth',
  swap('CalendarMonthIcon')
);
export const CalendarMonthOutlinedIcon = createMaterialIcon(
  MaterialCalendarMonthOutlined,
  'CalendarMonthOutlined',
  'CalendarMonthOutlined',
  swap('CalendarMonthOutlinedIcon')
);
export const CellTowerIcon = createMaterialIcon(
  MaterialCellTowerRounded,
  'CellTowerRounded',
  'CellTower',
  swap('CellTowerIcon')
);
export const ChatBubbleOutlineIcon = createMaterialIcon(
  MaterialChatBubbleOutline,
  'ChatBubbleOutline',
  'ChatBubbleOutline',
  swap('ChatBubbleOutlineIcon')
);
export const CheckBoxOutlinedIcon = createMaterialIcon(
  MaterialCheckBoxOutlined,
  'CheckBoxOutlined',
  'CheckBoxOutlined',
  swap('CheckBoxOutlinedIcon')
);
export const ClosedCaptionsIcon = createMaterialIcon(
  MaterialClosedCaption,
  'ClosedCaption',
  'ClosedCaptions',
  swap('ClosedCaptionsIcon')
);
export const ClosedCaptionsOutlinedIcon = createMaterialIcon(
  MaterialClosedCaptionOffOutlined,
  'ClosedCaptionOffOutlined',
  'ClosedCaptionsOutlined',
  swap('ClosedCaptionsOutlinedIcon')
);
export const CommitIcon = createMaterialIcon(MaterialCommit, 'Commit', 'Commit', swap('CommitIcon'));
export const ConstructionIcon = createMaterialIcon(
  MaterialConstructionRounded,
  'ConstructionRounded',
  'Construction',
  swap('ConstructionIcon')
);
export const EventIcon = createMaterialIcon(MaterialEvent, 'Event', 'Event', swap('EventIcon'));
export const FormatListNumberedIcon = createMaterialIcon(
  MaterialFormatListNumbered,
  'FormatListNumbered',
  'FormatListNumbered',
  swap('FormatListNumberedIcon')
);
export const ForumOutlinedIcon = createMaterialIcon(
  MaterialForumOutlined,
  'ForumOutlined',
  'ForumOutlined',
  swap('ForumOutlinedIcon')
);
export const FullscreenOutlinedIcon = createMaterialIcon(
  MaterialFullscreenOutlined,
  'FullscreenOutlined',
  'FullscreenOutlined',
  swap('FullscreenOutlinedIcon')
);
export const Groups2OutlinedIcon = createMaterialIcon(
  MaterialGroups2Outlined,
  'Groups2Outlined',
  'Groups2Outlined',
  swap('Groups2OutlinedIcon')
);
export const GroupsFilledIcon = createMaterialIcon(MaterialGroups, 'Groups', 'GroupsFilled', swap('GroupsFilledIcon'));
export const GroupsOutlinedIcon = createMaterialIcon(
  MaterialGroupsOutlined,
  'GroupsOutlined',
  'GroupsOutlined',
  swap('GroupsOutlinedIcon')
);
export const HeadphonesIcon = createMaterialIcon(
  MaterialHeadphones,
  'Headphones',
  'Headphones',
  swap('HeadphonesIcon')
);
export const HearingIcon = createMaterialIcon(MaterialHearing, 'Hearing', 'Hearing', swap('HearingIcon'));
export const HubOutlinedIcon = createMaterialIcon(
  MaterialHubOutlined,
  'HubOutlined',
  'HubOutlined',
  swap('HubOutlinedIcon')
);
export const InsertEmoticonOutlinedIcon = createMaterialIcon(
  MaterialInsertEmoticonOutlined,
  'InsertEmoticonOutlined',
  'InsertEmoticonOutlined',
  swap('InsertEmoticonOutlinedIcon')
);
export const LabelOutlinedIcon = createMaterialIcon(
  MaterialLabelOutlined,
  'LabelOutlined',
  'LabelOutlined',
  swap('LabelOutlinedIcon')
);
export const LanguageIcon = createMaterialIcon(MaterialLanguage, 'Language', 'Language', swap('LanguageIcon'));
export const LogoutOutlinedIcon = createMaterialIcon(
  MaterialLogoutOutlined,
  'LogoutOutlined',
  'LogoutOutlined',
  swap('LogoutOutlinedIcon')
);
export const ManageAccountsOutlinedIcon = createMaterialIcon(
  MaterialManageAccountsOutlined,
  'ManageAccountsOutlined',
  'ManageAccountsOutlined',
  swap('ManageAccountsOutlinedIcon')
);
export const PauseIcon = createMaterialIcon(MaterialPause, 'Pause', 'Pause', swap('PauseIcon'));
export const PauseOutlinedIcon = createMaterialIcon(
  MaterialPauseOutlined,
  'PauseOutlined',
  'PauseOutlined',
  swap('PauseOutlinedIcon')
);
export const PeopleAltOutlinedIcon = createMaterialIcon(
  MaterialPeopleAltOutlined,
  'PeopleAltOutlined',
  'PeopleAltOutlined',
  swap('PeopleAltOutlinedIcon')
);
export const PersonAddAlt1OutlinedIcon = createMaterialIcon(
  MaterialPersonAddAlt1Outlined,
  'PersonAddAlt1Outlined',
  'PersonAddAlt1Outlined',
  swap('PersonAddAlt1OutlinedIcon')
);
export const PersonAddAltOutlinedIcon = createMaterialIcon(
  MaterialPersonAddAltOutlined,
  'PersonAddAltOutlined',
  'PersonAddAltOutlined',
  swap('PersonAddAltOutlinedIcon')
);
export const PersonOffOutlinedIcon = createMaterialIcon(
  MaterialPersonOffOutlined,
  'PersonOffOutlined',
  'PersonOffOutlined',
  swap('PersonOffOutlinedIcon')
);
export const PlayArrowIcon = createMaterialIcon(MaterialPlayArrow, 'PlayArrow', 'PlayArrow', swap('PlayArrowIcon'));
export const PlayArrowOutlinedIcon = createMaterialIcon(
  MaterialPlayArrowOutlined,
  'PlayArrowOutlined',
  'PlayArrowOutlined',
  swap('PlayArrowOutlinedIcon')
);
export const QueryStatsOutlinedIcon = createMaterialIcon(
  MaterialQueryStatsOutlined,
  'QueryStatsOutlined',
  'QueryStatsOutlined',
  swap('QueryStatsOutlinedIcon')
);
export const QuestionAnswerOutlinedIcon = createMaterialIcon(
  MaterialQuestionAnswerOutlined,
  'QuestionAnswerOutlined',
  'QuestionAnswerOutlined',
  swap('QuestionAnswerOutlinedIcon')
);
export const RocketOutlinedIcon = createMaterialIcon(
  MaterialRocketOutlined,
  'RocketOutlined',
  'RocketOutlined',
  swap('RocketOutlinedIcon')
);
export const SettingsInputAntennaIcon = createMaterialIcon(
  MaterialSettingsInputAntenna,
  'SettingsInputAntenna',
  'SettingsInputAntenna',
  swap('SettingsInputAntennaIcon')
);
export const SettingsOutlinedIcon = createMaterialIcon(
  MaterialSettingsOutlined,
  'SettingsOutlined',
  'SettingsOutlined',
  swap('SettingsOutlinedIcon')
);
export const SpeedIcon = createMaterialIcon(MaterialSpeed, 'Speed', 'Speed', swap('SpeedIcon'));
export const StopIcon = createMaterialIcon(MaterialStop, 'Stop', 'Stop', swap('StopIcon'));
export const SupportOutlinedIcon = createMaterialIcon(
  MaterialSupportOutlined,
  'SupportOutlined',
  'SupportOutlined',
  swap('SupportOutlinedIcon')
);
export const TagOutlinedIcon = createMaterialIcon(
  MaterialTagOutlined,
  'TagOutlined',
  'TagOutlined',
  swap('TagOutlinedIcon')
);
export const TimelineOutlinedIcon = createMaterialIcon(
  MaterialTimelineOutlined,
  'TimelineOutlined',
  'TimelineOutlined',
  swap('TimelineOutlinedIcon')
);
export const UnpublishedOutlinedIcon = createMaterialIcon(
  MaterialUnpublishedOutlined,
  'UnpublishedOutlined',
  'UnpublishedOutlined',
  swap('UnpublishedOutlinedIcon')
);
export const VerifiedOutlinedIcon = createMaterialIcon(
  MaterialVerifiedOutlined,
  'VerifiedOutlined',
  'VerifiedOutlined',
  swap('VerifiedOutlinedIcon')
);
export const VolumeDownIcon = createMaterialIcon(
  MaterialVolumeDown,
  'VolumeDown',
  'VolumeDown',
  swap('VolumeDownIcon')
);
export const VolumeUpIcon = createMaterialIcon(MaterialVolumeUp, 'VolumeUp', 'VolumeUp', swap('VolumeUpIcon'));
export const WifiIcon = createMaterialIcon(MaterialWifi, 'Wifi', 'Wifi', swap('WifiIcon'));
export const AddIcon = createSvgIcon(Add, 'Add', swap('AddIcon'));
/** A smiley with a plus: "open the full emoji list". Material's `add_reaction`, the glyph Google Meet uses. */
export const AddReactionIcon = createMaterialIcon(
  MaterialAddReactionOutlined,
  'AddReaction',
  'AddReaction',
  swap('AddReactionIcon')
);
export const ArrowRightIcon = createSvgIcon(ArrowRight, 'ArrowRight', swap('ArrowRightIcon'));
export const AutoRenewIcon = createSvgIcon(AutoRenew, 'AutoRenew', swap('AutoRenewIcon'));
export const BarChartIcon = createSvgIcon(BarChart, 'BarChart', swap('BarChartIcon'));
export const BookSparkIcon = createSvgIcon(BookSpark, 'BookSpark', swap('BookSparkIcon'));
export const CalendarIcon = createSvgIcon(Calendar, 'Calendar', swap('CalendarIcon'));
export const CancelPresentationFilledIcon = createSvgIcon(
  CancelPresentationFilled,
  'CancelPresentationFilled',
  swap('CancelPresentationFilledIcon')
);
export const ChartSelectIcon = createSvgIcon(ChartSelect, 'ChartSelect', swap('ChartSelectIcon'));
export const ChatIcon = createSvgIcon(Chat, 'Chat', swap('ChatIcon'));
export const CheckFilledIcon = createSvgIcon(CheckFilled, 'CheckFilled', swap('CheckFilledIcon'));
export const CheckIcon = createSvgIcon(Check, 'Check', swap('CheckIcon'));
export const ChevronDownIcon = createSvgIcon(ChevronDown, 'ChevronDown', swap('ChevronDownIcon'));
export const ChevronLeftIcon = createSvgIcon(ChevronLeft, 'ChevronLeft', swap('ChevronLeftIcon'));
export const ChevronRightIcon = createSvgIcon(ChevronRight, 'ChevronRight', swap('ChevronRightIcon'));
export const ChevronUpIcon = createSvgIcon(ChevronUp, 'ChevronUp', swap('ChevronUpIcon'));
export const CloseIcon = createSvgIcon(Close, 'Close', swap('CloseIcon'));
export const CopyIcon = createSvgIcon(Copy, 'Copy', swap('CopyIcon'));
export const DeleteIcon = createSvgIcon(Delete, 'Delete', swap('DeleteIcon'));
export const DoubleArrowLeftIcon = createSvgIcon(DoubleArrowLeft, 'DoubleArrowLeft', swap('DoubleArrowLeftIcon'));
export const DownloadIcon = createSvgIcon(Download, 'Download', swap('DownloadIcon'));
export const DragIndicatorIcon = createSvgIcon(DragIndicator, 'DragIndicator', swap('DragIndicatorIcon'));
export const DuplicateIcon = createSvgIcon(Duplicate, 'Duplicate', swap('DuplicateIcon'));
export const EditIcon = createSvgIcon(Edit, 'Edit', swap('EditIcon'));
export const EmojiFilledIcon = createSvgIcon(EmojiFilled, 'EmojiFilled', swap('EmojiFilledIcon'));
export const EmojiOutlinedIcon = createSvgIcon(EmojiOutlined, 'EmojiOutlined', swap('EmojiOutlinedIcon'));
export const ErrorFilledIcon = createSvgIcon(ErrorFilled, 'ErrorFilled', swap('ErrorFilledIcon'));
export const ErrorOutlinedIcon = createSvgIcon(ErrorOutlined, 'ErrorOutlined', swap('ErrorOutlinedIcon'));
export const ExitToAppIcon = createSvgIcon(ExitToApp, 'ExitToApp', swap('ExitToAppIcon'));
export const FilterIcon = createSvgIcon(Filter, 'Filter', swap('FilterIcon'));
export const ForumIcon = createSvgIcon(Forum, 'Forum', swap('ForumIcon'));
export const FramePersonIcon = createSvgIcon(FramePersonOn, 'FramePerson', swap('FramePersonIcon'));
export const FramePersonOffIcon = createSvgIcon(FramePersonOff, 'FramePersonOff', swap('FramePersonOffIcon'));
export const HandFilledIcon = createSvgIcon(HandFilled, 'HandFilled', swap('HandFilledIcon'));
export const HandOutlinedIcon = createSvgIcon(HandOutlined, 'HandOutlined', swap('HandOutlinedIcon'));
export const HelpOutlinedIcon = createSvgIcon(HelpOutlined, 'HelpOutlined', swap('HelpOutlinedIcon'));
export const HomeOutlinedIcon = createSvgIcon(HomeOutlined, 'HomeOutlined', swap('HomeOutlinedIcon'));
export const ImageIcon = createSvgIcon(Image, 'Image', swap('ImageIcon'));
export const InfoFilledIcon = createSvgIcon(InfoFilled, 'InfoFilled', swap('InfoFilledIcon'));
export const InfoOutlinedIcon = createSvgIcon(InfoOutlined, 'InfoOutlined', swap('InfoOutlinedIcon'));
export const InsightsIcon = createSvgIcon(Insights, 'Insights', swap('InsightsIcon'));
export const LinkIcon = createSvgIcon(Link, 'Link', swap('LinkIcon'));
export const LockIcon = createSvgIcon(Lock, 'Lock', swap('LockIcon'));
export const LoginIcon = createSvgIcon(Login, 'Login', swap('LoginIcon'));
export const LogoutIcon = createSvgIcon(Logout, 'Logout', swap('LogoutIcon'));
export const MenuIcon = createSvgIcon(Menu, 'Menu', swap('MenuIcon'));
export const MicrophoneOffOutlinedIcon = createSvgIcon(
  MicrophoneOffOutlined,
  'MicrophoneOffOutlined',
  swap('MicrophoneOffOutlinedIcon')
);

export const GoogleColouredIcon = createSvgIcon(GoogleColoured, 'GoogleColoured', swap('GoogleColouredIcon'));
export const OutlookColouredIcon = createSvgIcon(OutlookColoured, 'OutlookColoured', swap('OutlookColouredIcon'));
export const MicrophoneOffFilledIcon = createSvgIcon(
  MicrophoneOffFilled,
  'MicrophoneOffFilled',
  swap('MicrophoneOffFilledIcon')
);
export const MicrophoneOnIcon = createSvgIcon(MicrophoneOn, 'MicrophoneOn', swap('MicrophoneOnIcon'));
export const MoreHorizontalIcon = createSvgIcon(MoreHorizontal, 'MoreHorizontal', swap('MoreHorizontalIcon'));
export const MoreVerticalIcon = createSvgIcon(MoreVertical, 'MoreVertical', swap('MoreVerticalIcon'));
export const PhoneFilledIcon = createSvgIcon(PhoneFilled, 'PhoneFilled', swap('PhoneFilledIcon'));
export const PinIcon = createSvgIcon(Pin, 'Pin', swap('PinIcon'));
export const PlayCircleIcon = createSvgIcon(PlayCircle, 'PlayCircle', swap('PlayCircleIcon'));
export const PowerSettingsIcon = createSvgIcon(PowerSettings, 'Power', swap('PowerSettingsIcon'));
export const PresentToAllIcon = createSvgIcon(PresentToAll, 'PresentToAll', swap('PresentToAllIcon'));
export const RadioButtonCheckedIcon = createSvgIcon(
  RadioButtonChecked,
  'RadioButtonChecked',
  swap('RadioButtonCheckedIcon')
);
export const RaisedHandIcon = createSvgIcon(RaisedHand, 'RaisedHand', swap('RaisedHandIcon'));
/**
 * The reactions control's glyph: today's emoji face, confetti under the refresh (HNS-366).
 *
 * Shares `EmojiOutlined.svg` with `EmojiOutlinedIcon` on purpose — with the flag off the two are the
 * same pixels, and only the Phosphor side differs. See `phosphorMapping` for why the chat's emoji
 * picker must not follow this one to confetti.
 */
export const ReactionsIcon = createSvgIcon(EmojiOutlined, 'Reactions', swap('ReactionsIcon'));
export const ReplayIcon = createSvgIcon(Replay, 'Replay', swap('ReplayIcon'));
export const ScreenShareIcon = createSvgIcon(ScreenShare, 'ScreenShare', swap('ScreenShareIcon'));
export const SendIcon = createSvgIcon(Send, 'Send', swap('SendIcon'));
export const SearchIcon = createSvgIcon(Search, 'Search', swap('SearchIcon'));
export const SettingsAccountIcon = createSvgIcon(SettingsAccount, 'SettingsAccount', swap('SettingsAccountIcon'));
export const SettingsFilledIcon = createSvgIcon(SettingsFilled, 'SettingsFilled', swap('SettingsFilledIcon'));
export const SettingsIcon = createSvgIcon(Settings, 'Settings', swap('SettingsIcon'));
export const ShareIcon = createSvgIcon(Share, 'Share', swap('ShareIcon'));
export const ShareScreenIcon = createSvgIcon(ShareScreen, 'ShareScreen', swap('ShareScreenIcon'));
export const SpeakerIcon = createSvgIcon(Speaker, 'Speaker', swap('SpeakerIcon'));
export const StarIcon = createSvgIcon(Star, 'Star', swap('StarIcon'));
export const TriangleArrowDownIcon = createSvgIcon(
  TriangleArrowDown,
  'TriangleArrowDown',
  swap('TriangleArrowDownIcon')
);
export const TriangleArrowUpIcon = createSvgIcon(TriangleArrowUp, 'TriangleArrowUp', swap('TriangleArrowUpIcon'));
export const UploadIcon = createSvgIcon(Upload, 'Upload', swap('UploadIcon'));
export const VideocamIcon = createSvgIcon(Videocam, 'Videocam', swap('VideocamIcon'));
export const VideocamOffIcon = createSvgIcon(VideocamOff, 'VideocamOff', swap('VideocamOffIcon'));
export const VideocamOutlinedIcon = createSvgIcon(VideocamOutlined, 'VideocamOutlined', swap('VideocamOutlinedIcon'));
export const VisibilityOffIcon = createSvgIcon(VisibilityOff, 'VisibilityOff', swap('VisibilityOffIcon'));
export const VisibilityOnIcon = createSvgIcon(VisibilityOn, 'VisibilityOn', swap('VisibilityOnIcon'));
export const VisibilityLockIcon = createSvgIcon(VisibilityLock, 'VisibilityLock', swap('VisibilityLockIcon'));
export const VoiceOverOffIcon = createSvgIcon(VoiceOverOff, 'VoiceOverOff', swap('VoiceOverOffIcon'));
export const WarningFilledIcon = createSvgIcon(WarningFilled, 'WarningFilled', swap('WarningFilledIcon'));
export const WarningOutlinedIcon = createSvgIcon(WarningOutlined, 'WarningOutlined', swap('WarningOutlinedIcon'));
export const RecordVoiceOverIcon = createSvgIcon(RecordVoiceOver, 'RecordVoiceOver', swap('RecordVoiceOverIcon'));
export const PersonOutlinedIcon = createSvgIcon(PersonOutlined, 'PersonOutlined', swap('PersonOutlinedIcon'));
export const GroupOutlinedIcon = createSvgIcon(GroupOutlined, 'GroupOutlined', swap('GroupOutlinedIcon'));
export const ArrowUpIcon = createSvgIcon(ArrowUp, 'ArrowUp', swap('ArrowUpIcon'));
export const BorderColorIcon = createSvgIcon(BorderColor, 'BorderColor', swap('BorderColorIcon'));
export const WifiBadIcon = createSvgIcon(WifiBad, 'WifiBad', swap('WifiBadIcon'));
export const WifiMediumIcon = createSvgIcon(WifiMedium, 'WifiMedium', swap('WifiMediumIcon'));
export const WifiOkIcon = createSvgIcon(WifiOk, 'WifiOk', swap('WifiOkIcon'));
export const RestartIcon = createSvgIcon(Restart, 'Restart', swap('RestartIcon'));
export const ParticipantsIcon = createSvgIcon(Participants, 'Participants', swap('ParticipantsIcon'));
